export default __webpack_public_path__ + "static/media/blightedtouch.2c90dec6.png";